export default __webpack_public_path__ + "static/media/voice_slider001.70d718fc.png";